module.exports = __webpack_public_path__ + "img/icon_zoho.97a7de53.png";